import React, { useContext, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import translate from '../../../translate';
import Loader from '../../../../services/loader';
import { newFormatPrice } from '../../../../services/utilityFunctions';
import LoggedUserContext from '../../../../contextProviders/LoggedUserContext';
import MarketInfosContext from '../../../../contextProviders/MarketInfosContext';
import ShopCartContext from '../../../../contextProviders/ShopCartContext';
import {
  getCheckoutProductEndpoint,
  getCheckoutProductList,
} from '../../../../sections/shop/shopHelper';
import { useQuery } from '../../../../services/customHooks';

function HeaderCartPopup({ t, cart, onTotalProducts }) {
  const query = useQuery();
  const journeySlug = query.get('journey');

  const { loggedUser } = useContext(LoggedUserContext);
  const { marketInfos } = useContext(MarketInfosContext);
  const { setShopCart } = useContext(ShopCartContext);
  const userCurrencyCode =
    loggedUser && loggedUser.currency
      ? loggedUser.currency.toUpperCase()
      : marketInfos.localCurrency;
  // Loader
  const loader = useRef(new Loader('#cartPopupItems'));
  const [isLoading, setLoading] = useState(false);
  const [cartState, setCartState] = useState([]);
  const [cartTotal, setCartTotal] = useState(0);
  // Make sure that we made any change in cart, so we update de shopCart context
  const [cartStateUpdated, setCartStateUpdated] = useState(false);
  useEffect(() => {
    setCartStateUpdated(true);
  }, [cartState]);
  // Get Variations
  const handleFetchVariation = cartToFetch => {
    setLoading(true);
    const { endpoint, products, variations } =
      getCheckoutProductEndpoint(cartToFetch);
    axios
      .get(endpoint, {
        params: {
          populate: ['variations', 'category', 'owner'],
        },
        headers: {
          'Accept-Version': '1.0.0',
          'X-Gamification-API': 'Games',
        },
      })
      .then(({ data: response }) => {
        const result = response.data;
        /**
         *   // region Find cart variations in parent product
         *         const productVariations = variations
         *           .map(variationId => {
         *             const product = result.find(parentProduct =>
         *               parentProduct.variations.find(
         *                 variationProduct => variationProduct._id === variationId,
         *               ),
         *             );
         *             if (!product) {
         *               return null;
         *             }
         *             return product.variations.find(v => v._id === variationId);
         *           })
         *           .filter(p => p);
         *         // endregion Find cart variations in parent product
         *
         *         // region Find pack product
         *         const packProducts = products
         *           .map(productId => {
         *             const product = result.find(
         *               parentProduct => parentProduct._id === productId,
         *             );
         *             if (!product) {
         *               return null;
         *             }
         *             return product;
         *           })
         *           .filter(p => p);
         *         // endregion Find pack product
         *
         *         // region Compare to check if all products are available
         *         if (
         *           [...variations, ...products].length >
         *           [...productVariations, ...packProducts].length
         *         ) {
         *           Notifications.showNotificationWarning(
         *             t('warning'),
         *             t('shop.checkout.availability.products'),
         *           );
         *         }
         *         // endregion Compare to check if all products are available
         *
         *         // region show the actual cart after every match
         *         const newCart = cartToFetch.map(cartItem => {
         *           const { id: cartItemId, isPack } = cartItem;
         *           let product;
         *           // manage normal products
         *           if (!isPack) {
         *             product = result.find(parentProduct =>
         *               parentProduct.variations.find(
         *                 productVariation => productVariation._id === cartItemId,
         *               ),
         *             );
         *           } else {
         *             // manage pack products
         *             product = result.find(
         *               parentProduct => parentProduct._id === cartItemId,
         *             );
         *           }
         *           if (!product) {
         *             return null;
         *           }
         *
         *           // manage the pack information in a similar way to the variations
         *           const productItem = !isPack
         *             ? product.variations.find(v => v._id === cartItemId)
         *             : {
         *                 ...product,
         *                 ...product?.pack,
         *                 icon: product?.images[0],
         *               };
         *           return {
         *             ...cartItem,
         *             name: productItem.name,
         *             image: productItem.icon?.thumb,
         *           };
         *         });
         *         const cartToUpdate = newCart.filter(p => p !== null);
         *         // endregion show the actual cart after every match
         */
        const cartToUpdate = getCheckoutProductList(
          t,
          true,
          variations,
          products,
          cartToFetch,
          result,
        );

        // region Update cart popup
        onTotalProducts(cartToUpdate?.length || 0);
        setCartState(cartToUpdate);
        let cartTotalSum = 0;
        cartToUpdate.forEach(cartEl => {
          if (cartEl) {
            cartTotalSum += cartEl.price * cartEl.amount;
          }
        });
        setCartTotal(cartTotalSum);
        // endregion Update cart popup

        setLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  };
  // Delete cart and update value in cart
  const deleteCartItem = id => {
    const cartUpdated = cartState.filter(v => v.id !== id);
    // Fetch variation info for the products, after removed a product
    handleFetchVariation(cartUpdated);
    onTotalProducts(cartUpdated?.length || 0);
  };

  // When window unloads, update the context
  useEffect(() => {
    // Make sure that we made any change in cart, so we update de shopCart context
    // Without this state, if we don't render the dropdown, we would be reseting the
    // cart every time to the initial cartState = []
    // Now we only update the cart context, if the cartState is updated
    if (cartStateUpdated) {
      window.addEventListener('beforeunload', () => {
        setShopCart(cartState);
      });
    }
  }, [cartState]);

  // Loader handle
  useEffect(() => {
    if (loader.current) {
      if (isLoading) {
        loader.current.show();
      } else {
        loader.current.hide();
      }
    }
  }, [isLoading]);

  // Opening cart
  useEffect(() => {
    if (cart.length > 0) {
      handleFetchVariation(cart);
    }
  }, [cart]);

  return (
    <div className="m-dropdown__wrapper">
      <span
        className="m-dropdown__arrow m-dropdown__arrow--right m-dropdown__arrow--adjust"
        style={{ color: 'white' }}
      />
      <div className="m-dropdown__inner">
        <div
          className="m-dropdown__header m--align-left pt-3 pb-2 vertical-center"
          style={{ background: '#ffffff' }}
        >
          <h4 className="cart-popup-title">{t('your_cart')}</h4>
        </div>
        <div
          id="cartPopupItems"
          className="m-dropdown__body cart-popup-item-background"
        >
          <div className="m-dropdown__content">
            {cartState &&
              cartState.map(c => (
                <div key={c.id} className="row py-2">
                  <div className="col-3 vertical-center p-0">
                    <img
                      src={c.image}
                      alt={c.name}
                      className="cart-popup-item-img"
                    />
                  </div>
                  <div className="col-9">
                    <div className="row">
                      <div className="col-9">
                        <h4 className="cart-popup-product-title">{c.name}</h4>
                      </div>
                      <div className="col-3 vertical-center">
                        {/* eslint-disable-next-line max-len */}
                        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions */}
                        <i
                          onClick={() => deleteCartItem(c.id)}
                          className="flaticon-delete cart-popup-prod-del-btn"
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col text-left">
                        <span className="cart-popup-product-price no-wrap-value">
                          {newFormatPrice(c.price, false, userCurrencyCode)}
                        </span>
                      </div>
                      <div className="col text-right">
                        <span className="cart-popup-product-total">
                          {`${t('shop.product.total')}: `}
                        </span>
                        <span className="cart-popup-product-price no-wrap-value">
                          {newFormatPrice(
                            c.price * c.amount,
                            false,
                            userCurrencyCode,
                          )}
                        </span>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-2 vertical-center">
                        <span className="cart-popup-qty-lbl">{`${t(
                          'shop.cart.quantity_short',
                        )}:`}</span>
                      </div>
                      <div className="col-3 vertical-center">
                        <input
                          className="form-control m-input m-input--pill cart-popup-quantity text-center cart-popup-pill-override"
                          type="number"
                          disabled
                          value={c.amount}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        <div
          className="m-dropdown__footer m--align-left p-1"
          style={{ background: '#ffffff' }}
        >
          <div className="row px-3">
            <div className="col-12 text-right cart-popup-footer-total py-1">
              <span className="cart-popup-footer-total-lbl">
                {`${t('shop.product.total')}: `}
                <span className="no-wrap-value cart-popup-footer-price-lbl">
                  {newFormatPrice(cartTotal, false, userCurrencyCode)}
                </span>
              </span>
            </div>
            <div className="col-12 text-right py-2">
              <a
                className="btn m-btn--pill btn-dynamic cart-popup-go-cart-btn"
                href={`/shop/checkout${
                  journeySlug ? `?journey=${journeySlug}` : ''
                }`}
              >
                {t('shop.cart.go_to_cart')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

HeaderCartPopup.propTypes = {
  t: PropTypes.func.isRequired,
  cart: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      amount: PropTypes.number.isRequired,
      price: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      image: PropTypes.string.isRequired,
    }),
  ).isRequired,
  onTotalProducts: PropTypes.func.isRequired,
};

HeaderCartPopup.defaultProps = {};

export default translate(HeaderCartPopup);
